import { StatisticsBlock } from "@/shared/ui/statistics-block"
import CheckSvg from '@/shared/assets/images/Check.svg'
import UsersSvg from '@/shared/assets/images/UsersFour.svg'
import { useAppSelector } from "@/shared/lib/redux"
import { selectParticipations, selectRegistrationsCount } from "@/entities/marketing-campaign"

export const DefaultStatistics = () => {
    const totalParticipations = useAppSelector(selectParticipations)
    const totalRegistered = useAppSelector(selectRegistrationsCount)

    return (
        <div className='grid grid-cols-12 gap-4'>
            <div className="col-span-12 xxl:col-span-6">
                <StatisticsBlock
                    className="screen:!py-5"
                    icon={UsersSvg}
                    label='Количество участников'
                    value={`${totalParticipations}`}
                />
            </div>
            <div className="col-span-12 xxl:col-span-6">
                <StatisticsBlock
                    className="screen:!py-5 [&_div]:!shrink-0"
                    icon={CheckSvg}
                    label='Количество регистраций в кошельке'
                    value={`${totalRegistered}`}
                />
            </div>
        </div>
    )
}